var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { NATIVE_MINT } from "@solana/spl-token";
import { delay } from "./utils";
export function errorIfInsufficientBalance(Data) {
    var _a, e_1, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var values, mintAtas, mintAta, _d, mintAtas_1, mintAtas_1_1, ata, balance, error_1, e_1_1, balance, error_2, balance, message_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 28, , 29]);
                    if (!!NATIVE_MINT.toString().includes(Data.mint.toString())) return [3 /*break*/, 25];
                    values = [];
                    return [4 /*yield*/, Data.connection.getTokenAccountsByOwner(Data.owner, {
                            mint: Data.mint,
                        })];
                case 1:
                    mintAtas = (_e.sent()).value;
                    mintAta = mintAtas[0].pubkey;
                    if (!(mintAtas.length > 1)) return [3 /*break*/, 21];
                    console.log("more than 1 ata", mintAtas);
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 14, 15, 20]);
                    _d = true, mintAtas_1 = __asyncValues(mintAtas);
                    _e.label = 3;
                case 3: return [4 /*yield*/, mintAtas_1.next()];
                case 4:
                    if (!(mintAtas_1_1 = _e.sent(), _a = mintAtas_1_1.done, !_a)) return [3 /*break*/, 13];
                    _c = mintAtas_1_1.value;
                    _d = false;
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, , 11, 12]);
                    ata = _c;
                    _e.label = 6;
                case 6:
                    _e.trys.push([6, 9, , 10]);
                    return [4 /*yield*/, Data.connection.getTokenAccountBalance(ata.pubkey)];
                case 7:
                    balance = _e.sent();
                    return [4 /*yield*/, delay(500)];
                case 8:
                    _e.sent();
                    if (balance.value.uiAmount || balance.value.uiAmount === 0)
                        values.push({ value: balance.value.uiAmount, address: ata.pubkey });
                    return [3 /*break*/, 10];
                case 9:
                    error_1 = _e.sent();
                    if (String(error_1).includes("Invalid param: could not find mint")) {
                        throw "User ".concat(Data.owner.toBase58(), " with NFT ").concat(Data.mint.toBase58(), " has found no existance of the associated token account ").concat(ata.pubkey.toBase58());
                    }
                    else {
                        throw error_1;
                    }
                    return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 12];
                case 11:
                    _d = true;
                    return [7 /*endfinally*/];
                case 12: return [3 /*break*/, 3];
                case 13: return [3 /*break*/, 20];
                case 14:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 20];
                case 15:
                    _e.trys.push([15, , 18, 19]);
                    if (!(!_d && !_a && (_b = mintAtas_1.return))) return [3 /*break*/, 17];
                    return [4 /*yield*/, _b.call(mintAtas_1)];
                case 16:
                    _e.sent();
                    _e.label = 17;
                case 17: return [3 /*break*/, 19];
                case 18:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 19: return [7 /*endfinally*/];
                case 20:
                    values.sort(function (a, b) { return b.value - a.value; });
                    if (values[0].value < Data.amount)
                        throw "not enough balance ".concat(values[0].value, " < ").concat(Data.amount);
                    mintAta = values[0].address;
                    return [3 /*break*/, 24];
                case 21:
                    _e.trys.push([21, 23, , 24]);
                    return [4 /*yield*/, Data.connection.getTokenAccountBalance(mintAta)];
                case 22:
                    balance = _e.sent();
                    if (!!!balance.value.amount || Number(balance.value.amount) < Data.amount)
                        throw "not enough balance for ".concat(Data.mint.toBase58(), " from user ").concat(Data.owner.toBase58(), " ===>  ").concat((balance.value.amount), " < ").concat(Data.amount);
                    return [3 /*break*/, 24];
                case 23:
                    error_2 = _e.sent();
                    if (String(error_2).includes("Invalid param: could not find mint")) {
                        throw "User ".concat(Data.owner.toBase58(), " with NFT ").concat(Data.mint.toBase58(), " has found no existance of the associated token account ").concat(mintAta.toBase58());
                    }
                    else {
                        throw error_2;
                    }
                    return [3 /*break*/, 24];
                case 24: return [2 /*return*/, true];
                case 25: return [4 /*yield*/, Data.connection.getBalance(Data.owner)];
                case 26:
                    balance = _e.sent();
                    if (balance < Data.amount)
                        throw "not enough balance for native Sol from user ".concat(Data.owner.toBase58(), " ===>  ").concat(balance, " < ").concat(Data.amount);
                    return [2 /*return*/, true];
                case 27: return [3 /*break*/, 29];
                case 28:
                    message_1 = _e.sent();
                    console.log("no ata found", message_1);
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: message_1,
                    };
                case 29: return [2 /*return*/];
            }
        });
    });
}
